import { render, staticRenderFns } from "./Depoimento.vue?vue&type=template&id=7f7b459d"
import script from "./Depoimento.vue?vue&type=script&lang=js"
export * from "./Depoimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports